<template>
  <div :class="{ 'd-inline-flex align-middle mr-2': !botaoDropdown }">
    <template v-if="mostrarBotao">
      <template v-if="tipoBotao === 'texto'">
        <button
          type="button"
          class="btn btn-sm btn-warning font-weight-bold"
          @click.prevent="abrir"
        >
          <i class="fa fa-upload"></i>Enviar Manual
        </button>
      </template>
      <template v-else-if="tipoBotao == 'icone'">
        <b-button
          :variant="variant"
          size="sm"
          class="btn-icon"
          v-b-tooltip.noninteractive
          title="Enviar Manual"
          @click="abrir"
        >
          <i class="fas fa-file-upload"></i>
        </b-button>
      </template>
      <template v-else-if="tipoBotao === 'dropdown'">
        <b-dropdown-item @click.prevent="abrir"
          ><i class="fa fa-upload mr-2"></i>Enviar Manual</b-dropdown-item
        >
      </template>
    </template>

    <b-modal
      ref="mdlEnviarManual"
      @hidden="limpar"
      @shown="validacao"
      @ok="enviar"
      ok-title="Enviar"
      ok-variant="success"
      cancel-title="Cancelar"
      scrollable
      size="lg"
      ignore-enforce-focus-selector=".swal2-container"
    >
      <template #modal-title>
        Enviar Manual
        <span v-if="rotuloConta" class="modal-conta-inline ml-2">
          <i class="fas fa-building mr-1"></i>{{ rotuloConta }}
        </span>
      </template>

      <b-form ref="frmEnviarManual">
        <b-form-group>
          <label>Email para envio <span class="text-danger">*</span>:</label>
          <b-input-group>
            <!-- WEL-5199: o manual leva a senha da conta. O campo nasce
            bloqueado no e-mail cadastrado; alterar exige dupla verificação.
            O bloqueio real é do backend — inspecionar e destravar o input
            não muda o destino, que continua sendo o cadastrado. -->
            <b-form-input
              name="email"
              v-model="frmEnviarManual.email"
              :readonly="!destinoLiberado"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :variant="destinoLiberado ? 'success' : 'outline-secondary'"
                v-b-tooltip.hover
                :title="
                  destinoLiberado
                    ? 'Destino liberado — o manual irá para os e-mails informados'
                    : 'Alterar o destino exige dupla verificação'
                "
                @click="liberarDestino"
              >
                <i
                  :class="destinoLiberado ? 'fas fa-lock-open' : 'fas fa-lock'"
                ></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <small v-if="!destinoLiberado" class="text-muted">
            O manual será enviado aos e-mails cadastrados da conta. Para usar
            outro endereço, destrave o campo.
          </small>
        </b-form-group>
        <div
          v-html="frmEnviarManual.manual"
          class="bg-success-o-40 p-4 rounded"
        ></div>
      </b-form>
    </b-modal>

    <!-- WEL-5199: mesmo modal de código usado no bloqueio de tela. -->
    <ModalVerificacaoAcao ref="modalVerificacaoAcao" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import ModalVerificacaoAcao from "@/view/components/ModalVerificacaoAcao.vue";

export default {
  components: { ModalVerificacaoAcao },
  props: {
    conta: Object,
    variant: {
      type: String,
      default: "light-primary"
    },
    tipoBotao: {
      type: String,
      default: "icone"
    },
    mostrarBotao: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      frmEnviarManual: {
        id: null,
        email: "",
        manual: "",
        codigo: null
      },
      destinoLiberado: false,
      emailCadastrado: ""
    };
  },
  methods: {
    limpar() {
      this.frmEnviarManual = {
        id: null,
        email: "",
        manual: "",
        codigo: null
      };
      this.destinoLiberado = false;
      this.emailCadastrado = "";
    },

    // WEL-5199: destravar o campo exige o código de dupla verificação. O
    // código vai junto no envio — sem ele o backend ignora o que estiver
    // no campo e manda para os e-mails cadastrados da conta.
    async liberarDestino() {
      if (this.destinoLiberado) {
        // Voltar ao destino cadastrado é sempre permitido.
        this.destinoLiberado = false;
        this.frmEnviarManual.codigo = null;
        this.frmEnviarManual.email = this.emailCadastrado;
        return;
      }

      const codigo = await this.$refs.modalVerificacaoAcao.abrir(
        "Alterar o destino do manual",
        "O manual contém as credenciais da conta."
      );

      if (!codigo) return;

      this.frmEnviarManual.codigo = codigo;
      this.destinoLiberado = true;
    },

    abrir() {
      console.log("Abrindo modal para enviar manual");
      this.limpar();

      this.frmEnviarManual.id = this.conta.id;

      ApiService.post("conta/manual", { idConta: this.conta.id }).then(
        (response) => {
          this.frmEnviarManual.manual = response.data.data.manual;
          this.frmEnviarManual.email = response.data.data.email;
          // Guardado pra poder voltar ao destino cadastrado ao retravar.
          this.emailCadastrado = response.data.data.email;

          this.$refs["mdlEnviarManual"].show();
        }
      );
    },

    validacao() {
      const frmEnviarManual = this.$refs["frmEnviarManual"];

      this.fv = formValidation(frmEnviarManual, {
        fields: {
          email: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      });
    },

    enviar(e) {
      e.preventDefault();

      this.fv.validate().then((status) => {
        if (status == "Valid") {
          ApiService.post("conta/enviarManual", this.frmEnviarManual)
            .then(() => {
              this.$refs["mdlEnviarManual"].hide();

              Swal.fire({
                title: "MENSAGEM",
                text: "Manual enviado com sucesso!",
                icon: "success",
                heightAuto: false
              });
            })
            .catch(() => {
              for (const error in this.validatorErrors) {
                this.fv
                  .updateValidatorOption(
                    error,
                    "blank",
                    "message",
                    this.validatorErrors[error]
                  )
                  .updateFieldStatus(error, "Invalid", "blank");
              }
            });
        }
      });
    }
  },

  computed: {
    ...mapGetters(["validatorErrors"]),

    // Rotulo da conta p/ faixa de identificacao no topo do modal, evitando
    // agir na conta errada quando aberto pela Central de Contas. Login e o
    // fallback principal pois nome as vezes vem vazio (con_nome_identificacao
    // e opcional no backend).
    rotuloConta() {
      const nome = (this.conta?.nome || this.conta?.conNome || "").trim();
      const login = (this.conta?.login || "").trim();

      if (nome && login) return `${nome} (@${login})`;
      if (login) return `@${login}`;
      return nome;
    },

    botaoDropdown() {
      return this.tipoBotao === "dropdown";
    }
  }
};
</script>

<style scoped lang="scss"></style>
